import React from "react";
import "../../Styles/Settings/GeneralSetting.css";
import generalSettingIcon from "../../Assets/generalSettingIcon.png";
import ActiveGeneralSettingIcon from "../../Assets/ActiveGeneralSettingIcon.png";
import emailsettingIcon from "../../Assets/emailsettingIcon.png";
import activeemailsettingIcon from "../../Assets/activeemailsettingIcon.png";
import balanceIconforsetting from "../../Assets/balanceIconforsetting.png";
import activebalanceIconforsetting from "../../Assets/activebalanceIconforsetting.png";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
const SettingPage = () => {
  const nevigate = useNavigate();
  const location = useLocation();
  const lastSegment = location.pathname.split("/").pop();
  console.log(lastSegment);
  return (
    <div className="setting-maintab-container">
      <div className="setting-tab-container">
        <div className="setting-heading-tab">
          <p>Settings</p>
        </div>
        <div className="setting-nav-container">
          <div className="tabname-icon">
            <img
              src={
                lastSegment === "generalsetting"
                  ? ActiveGeneralSettingIcon
                  : generalSettingIcon
              }
              alt="settingIcons"
            />{" "}
            <p
              onClick={() => nevigate("generalsetting")}
              style={{
                color: lastSegment === "generalsetting" ? "#1B51BB " : "",
                // color: lastSegment === "generalsetting" ? "#1B51BB " : "",
                fontWeight: lastSegment === "generalsetting" ? 600 : 400,
                fontFamily:
                  lastSegment === "generalsetting"
                    ? "EuclidSemiBold"
                    : "EuclidMedium",
              }}
            >
              General setting
            </p>
          </div>
          <div className="tabname-icon">
            <img
              src={
                lastSegment === "Responsesetting"
                  ? activeemailsettingIcon
                  : emailsettingIcon
              }
              alt="settingIcons"
            />
            <p
              onClick={() => nevigate("Responsesetting")}
              style={{
                color: lastSegment === "Responsesetting" ? "#1B51BB " : "",
                fontWeight: lastSegment === "Responsesetting" ? 600 : 400,
                fontFamily:
                  lastSegment === "Responsesetting"
                    ? "EuclidSemiBold"
                    : "EuclidMedium",
              }}
            >
              Response
            </p>
          </div>
          <div className="tabname-icon">
            <img
              src={
                lastSegment === "emailsetting"
                  ? activeemailsettingIcon
                  : emailsettingIcon
              }
              alt="settingIcons"
            />{" "}
            <p
              onClick={() => nevigate("emailsetting")}
              style={{
                color: lastSegment === "emailsetting" ? "#1B51BB " : "",
                fontWeight: lastSegment === "emailsetting" ? 600 : 400,
                fontFamily:
                  lastSegment === "emailsetting"
                    ? "EuclidSemiBold"
                    : "EuclidMedium",
              }}
            >
              Email Settings
            </p>
          </div>
          <div className="tabname-icon">
            <img
              src={
                lastSegment === "thanksPage"
                  ? activebalanceIconforsetting
                  : balanceIconforsetting
              }
              alt="settingIcons"
            />
            <p
              onClick={() => nevigate("thanksPage")}
              style={{
                color: lastSegment === "thanksPage" ? "#1B51BB " : "",
                fontWeight: lastSegment === "thanksPage" ? 600 : 400,
                fontFamily:
                  lastSegment === "thanksPage"
                    ? "EuclidSemiBold"
                    : "EuclidMedium",
              }}
            >
              Thank You Page & Redirection
            </p>
          </div>
          <div className="tabname-icon">
            <img
              src={
                lastSegment === "Presentation"
                  ? activebalanceIconforsetting
                  : balanceIconforsetting
              }
              alt="settingIcons"
            />{" "}
            <p
              onClick={() => nevigate("Presentation")}
              style={{
                color: lastSegment === "Presentation" ? "#1B51BB " : "",
                fontWeight: lastSegment === "Presentation" ? 600 : 400,
                fontFamily:
                  lastSegment === "Presentation"
                    ? "EuclidSemiBold"
                    : "EuclidMedium",
              }}
            >
              Presentation
            </p>
          </div>
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default SettingPage;
